import { BannerProps } from './Interfaces'
import React from 'react'
import styled from 'styled-components'
import { ProgressBar, ProgressBarProps } from '@confer/lib'
import { VideoContainer } from './VideoContainer'

interface BannerComponentProps {
  userProps: BannerProps
  progressBarProps: ProgressBarProps
}

export const Banner = (props: BannerComponentProps) => {
  const { contentPath, contentType, pan, progressPan, controlsColour } = props.userProps

  switch (contentType) {
    case 'image':
      if (pan) {
        return (
          <ImagePanContainer>
            <Container>
              <img src={contentPath} alt="test.jpg" />
            </Container>
            <ProgressBar {...props.progressBarProps} />
          </ImagePanContainer>
        )
      } else if (progressPan) {
        return (
          <ProgressPanContainer progress={props.progressBarProps.percentage}>
            <Container>
              <img src={contentPath} alt="test.jpg" />
            </Container>
            <ProgressBar {...props.progressBarProps} />
          </ProgressPanContainer>
        )
      } else {
        return (
          <Container>
            <img src={contentPath} alt="test.jpg" />
            <ProgressBar {...props.progressBarProps} />
          </Container>
        )
      }

    case 'video':
      return (
        <Container>
          <VideoContainer videoPath={contentPath} controlsColour={controlsColour || '#888'} />
          <ProgressBar {...props.progressBarProps} />
        </Container>
      )
  }
}

const Container = styled.div`
  position: relative;
  display: flex;
  position: relative;
  width: 30vw;
  height: 100%;
  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: left;
  }
`

const ImagePanContainer = styled.div`
  width: 30vw;
  height: 100%;
  position: relative;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
  ${Container} {
    transform: translate3d(0, 0, 0);
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 300%;
    background-repeat: repeat;
    transform: translate3d(0, 0, 0);
    animation: slideshow 100s linear infinite;
    animation-direction: alternate;
    @keyframes slideshow {
      100% {
        transform: translateX(-66.66%);
      }
    }
  }
`

interface ProgressPanContainerProps {
  progress: number
}

const ProgressPanContainer = styled.div<ProgressPanContainerProps>`
  width: 30vw;
  height: 100%;
  position: relative;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
  ${Container} {
    transform: translate3d(0, 0, 0);
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 300%;
    background-repeat: repeat;
    /* transform: translate3d(0, 0, 0); */
    transform: translateX(${(props) => (-props.progress * 2) / 3}%);
    transition: transform 0.5s;
    /* animation: slideshow 100s linear infinite;
    animation-direction: alternate;
    @keyframes slideshow {
      100% {
        transform: translateX(-66.66%);
      }
    } */
  }
`
